import React, { useRef, useState } from 'react';
import { HoneyPot, FormNote } from '../../components/FormParts';
import { formValues, registerForEvent } from '../../lib/api/forms';

// Sign-up form shown on an event page when the campus has opened registration for that event.
const EventRegistration = ({ slug }) => {
  const formRef = useRef(null);
  const [state, setState] = useState({ status: 'idle', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setState({ status: 'sending', message: '' });
    try {
      await registerForEvent({ ...formValues(formRef.current), eventSlug: slug });
      formRef.current.reset();
      setState({ status: 'success', message: 'Thank you. You are registered. We will be in touch with more details.' });
    } catch (err) {
      setState({ status: 'error', message: err.message });
    }
  };

  return (
    <div className="it-evn-details-text mt-50">
      <h6 className="it-evn-details-title-sm pb-10">Register For This Event</h6>
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-25">
            <div className="it-contact-input-box">
              <label>Full Name*</label>
              <input type="text" name="fullName" placeholder="Full name" required maxLength={120} />
            </div>
          </div>
          <div className="col-md-6 mb-25">
            <div className="it-contact-input-box">
              <label>Email*</label>
              <input type="email" name="email" placeholder="Email" required maxLength={200} />
            </div>
          </div>
          <div className="col-md-6 mb-25">
            <div className="it-contact-input-box">
              <label>Phone</label>
              <input type="tel" name="phone" placeholder="Phone" maxLength={30} />
            </div>
          </div>
          <div className="col-md-6 mb-25">
            <div className="it-contact-input-box">
              <label>Note</label>
              <input type="text" name="notes" placeholder="Anything we should know" maxLength={1000} />
            </div>
          </div>
        </div>
        <HoneyPot />
        <button type="submit" className="ed-btn-square radius purple-4" disabled={state.status === 'sending'}>
          <span>{state.status === 'sending' ? 'Sending...' : 'Register'}</span>
        </button>
        <FormNote status={state.status}>{state.message}</FormNote>
      </form>
    </div>
  );
};
export default EventRegistration;
